import { Create, SimpleForm } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import SaveForm from "./SaveForm";

const CreateGoogleCourses = () => {
  return (
    <Create
      title="Създаване на Google Зали"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};
export default CreateGoogleCourses;
